import { isNonNullable, isNullable } from '@ipfabric/utils';
import { assoc } from 'ramda';

const searchText = (text, q) => {
  const re = new RegExp(q, 'gi');
  return text.toLowerCase().match(re);
};

const searchInUrl = (item, reportsList, q, preselectReport) => {
  if (reportsList[item]) {
    const matchUrl = reportsList[item].reduce((acc, report) => {
      if (isNonNullable(preselectReport) && preselectReport === report.id) {
        return acc.concat(preselectReport);
      }
      if (isNullable(preselectReport)) {
        const match = searchText(report.name, q);
        if (!match || !match.length) {
          return acc;
        }
        return acc.concat(report.id);
      }
      return acc;
    }, []);
    if (matchUrl.length) {
      return matchUrl;
    }
  }
  return null;
};

const findResults = (tree, q, results, reportsList, preselectReport) => {
  if (Array.isArray(tree)) {
    const keys = Object.keys(tree);
    // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
    const newResults = keys.reduce((acc, key) => {
      const item = tree[key];
      // url from urlList
      if (typeof item === 'string') {
        const match = searchInUrl(item, reportsList, q, preselectReport);
        if (match) {
          return assoc(item, match, acc);
        }
        return acc;
      }
      // item from urlList
      if (item.url) {
        const match = searchInUrl(item.url, reportsList, q, preselectReport);
        if (match) {
          return assoc(item.url, match, acc);
        }
        return acc;
      }
      const accWithUrlList = item.urlList
        ? findResults(item.urlList, q, acc, reportsList, preselectReport)
        : acc;
      const accWithChildren = item.children
        ? findResults(
            item.children,
            q,
            accWithUrlList,
            reportsList,
            preselectReport,
          )
        : accWithUrlList;
      return accWithChildren;
    }, results);
    return newResults;
  }
  return results;
};

export default findResults;
